import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2021/Lic/C"; 

export const licitaciones2021=[
    {
        // CONVOCATORIA NUM# 015
            'numConvocatoria' : 'Convocatoria No. 015/2021.',
            'idConvocatoria' : 'Convocatoria15',
            'procedimientos' : [
        // Licitación N26
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N26-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 20 de diciembre  de 2021.',
                    'descripcionProcedimiento' : 'Sustitución y ampliación del Hospital General de Pachuca (instalación eléctrica (alumbrado y contactos), sistema de tierras, tableros de aislamiento, alineadores eléctricos, acometida eléctrica 1a etapa, subestación eléctrica 1a etapa, sistema contra incendio); ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N26/N26.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N26/JAN26.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N26/APN26.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N26/FAN26.pdf`,
                    },
                    ],
                },
        // Licitación N25
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N25-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 20 de diciembre  de 2021.',
                    'descripcionProcedimiento' : 'Sustitución y ampliación del Hospital General de Pachuca (albañilería, azotea, instalaciones hidráulica, sanitaria y pluvial); ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }15/N25/N25.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }15/N25/JAN25.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }15/N25/APN25.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }15/N25/FAN25.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 014
            'numConvocatoria' : 'Convocatoria No. 014/2021.',
            'idConvocatoria' : 'Convocatoria14',
            'procedimientos' : [
        // Licitación N24
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N24-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 13 al 20 de diciembre  de 2021.',
                    'descripcionProcedimiento' : 'Centro de identificación humana para resguardo temporal de Hidalgo (Ambientación de infraestructura existente); de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }14/N24/N24.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }14/N24/JAN24.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }14/N24/APN24.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }14/N24/FAN24.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 013
            'numConvocatoria' : 'Convocatoria No. 013/2021.',
            'idConvocatoria' : 'Convocatoria13',
            'procedimientos' : [
        // Licitación N23
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N23-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 6 al 10 de diciembre  de 2021.',
                    'descripcionProcedimiento' : 'Memorial Hidalgo COVID19, ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }13/N23/N23.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }13/N23/JAN23.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }13/N23/APN23.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }13/N23/FAN23.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }13/N23/AMDFAN23.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 012
            'numConvocatoria' : 'Convocatoria No. 012/2021.',
            'idConvocatoria' : 'Convocatoria12',
            'procedimientos' : [
        // Licitación N22
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N22-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 29 de noviembre al 3 de diciembre  de 2021.',
                    'descripcionProcedimiento' : 'Construcción del Sistema de Alcantarillado Sanitario Zona Centro para beneficiar a la localidad de Acatepec, en el municipio de Huautla, ubicada en la localidad de Acatepec, Municipio de Huautla, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }12/N22/N22.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }12/N22/JAN22.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }12/N22/APN22.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }12/N22/FAN22.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 011
            'numConvocatoria' : 'Convocatoria No. 011/2021.',
            'idConvocatoria' : 'Convocatoria11',
            'procedimientos' : [
        // Licitación N21
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N21-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 15 al 22 de noviembre  de 2021.',
                    'descripcionProcedimiento' : 'Sustitución y ampliación del Hospital General de Pachuca (fachada acabados, cancelería y herrería, voz y datos, sistema de sonido, CCTV, sistema enfermo enfermera, gas LP); ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N21/N21.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N21/JAN21.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N21/APN21.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N21/FAN21.pdf`,
                    },
                    ],
                },
        // Licitación N20
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N20-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 15 al 22 de noviembre  de 2021.',
                    'descripcionProcedimiento' : 'Sustitución y ampliación del Hospital General de Pachuca (accesorios, acabados, carpintería, muebles sanitarios, accesorios sanitarios, señalética, alumbrado exterior, pararrayos, RPBI, obra exterior, caseta de vigilancia, estacionamiento); ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }11/N20/N20.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }11/N20/JAN20.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }11/N20/APN20.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }11/N20/FAN20.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 010
            'numConvocatoria' : 'Convocatoria No. 010/2021.',
            'idConvocatoria' : 'Convocatoria10',
            'procedimientos' : [
        // Licitación N19
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N19-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 11 al 15 de octubre  de 2021.',
                    'descripcionProcedimiento' : 'Modernización del Blvd. Felipe Ángeles Km 87.85; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }10/N19/N19.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }10/N19/JAN19.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }10/N19/APN19.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }10/N19/FAN19.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 008
            'numConvocatoria' : 'Convocatoria No. 008/2021.',
            'idConvocatoria' : 'Convocatoria8',
            'procedimientos' : [
        // Licitación N17
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N17-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de agosto  de 2021.',
                    'descripcionProcedimiento' : 'Mejoramiento del Cuartel la Paz de la Secretaría de Seguridad Pública; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N17/N17.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N17/JAN17.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N17/APN17.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N17/FAN17.pdf`,
                    },
                    ],
                },
        // Licitación N16
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N16-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de agosto  de 2021.',
                    'descripcionProcedimiento' : 'Mejoramiento de la base de operaciones de Ixmiquilpan Hgo. de la Secretaría de Seguridad Pública; ubicada en la localidad y Municipio de Ixmiquilpan, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N16/N16.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N16/JAN16.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N16/APN16.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N16/FAN16.pdf`,
                    },
                    ],
                },
        // Licitación N15
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N15-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de agosto  de 2021.',
                    'descripcionProcedimiento' : 'Mejoramiento del Instituto de Formación Profesional; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }8/N15/N15.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N15/JAN15.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N15/APN15.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N15/FAN15.pdf`,
                    },
                    ],
                },
        // Licitación N14
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N14-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de agosto  de 2021.',
                    'descripcionProcedimiento' : 'Mejoramiento de la base de operaciones mixtas Tulancingo, Hgo. de la Secretaría de Seguridad Pública; ubicada en la localidad de Nueva Morelos, Municipio de Tulancingo de Bravo, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N14/N14.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N14/JAN14.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N14/APN14.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N14/FAN14.pdf`,
                    },
                    ],
                },
        // Licitación N13
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N13-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de agosto  de 2021.',
                    'descripcionProcedimiento' : 'Mejoramiento de la base de operaciones de Huejutla, Hgo. de la Secretaría de Seguridad Pública; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N13/N13.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N13/JAN13.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N13/APN13.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N13/FAN13.pdf`,
                    },
                    ],
                },
        // Licitación N12
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N12-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de agosto  de 2021.',
                    'descripcionProcedimiento' : 'Mejoramiento de la Secretaría de Seguridad Pública; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N12/N12.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N12/JAN12.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N12/APN12.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N12/FAN12.pdf`,
                    },
                    ],
                },
        // Licitación N11
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N11-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 2 al 6 de agosto  de 2021.',
                    'descripcionProcedimiento' : 'Mejoramiento del Cereso Tula de Allende; ubicado en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }8/N11/N11.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }8/N11/JAN11.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }8/N11/APN11.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }8/N11/FAN11.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 007
            'numConvocatoria' : 'Convocatoria No. 007/2021.',
            'idConvocatoria' : 'Convocatoria7',
            'procedimientos' : [
        // Licitación N10
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N10-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 23 de julio  de 2021.',
                    'descripcionProcedimiento' : 'Reforestación y adecuación de camellones en Blvd Nuevo Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }7/N10/N10.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N10/JAN10.pdf`,
                    },
                    ],
                },
        // Licitación N9
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N9-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 23 de julio  de 2021.',
                    'descripcionProcedimiento' : 'Reforestación y adecuación de camellones en Supervía Colosio Tramo Blvd. Nvo. Hidalgo al Blvd Valle de San Javier; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }7/N9/N9.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }7/N9/JAN9.pdf`,
                    },
                    ],
                },
            ],
    },    
    {
        // CONVOCATORIA NUM# 006
            'numConvocatoria' : 'Convocatoria No. 006/2021.',
            'idConvocatoria' : 'Convocatoria6',
            'procedimientos' : [
        // Licitación N8
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N8-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 23 de julio  de 2021.',
                    'descripcionProcedimiento' : 'Construcción de las oficinas del Centro Federal Conciliación y Registro Laboral, en Ciudad Laboral; de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }6/N8/N8.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }6/N8/JAN8.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }6/N8/APN8.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }6/N8/FAN8.pdf`,
                    },
                    ],
                },
        // Licitación N7
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N7-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 19 al 23 de julio  de 2021.',
                    'descripcionProcedimiento' : 'Construcción de las oficinas del Centro de Conciliación Laboral Estatal, en Ciudad Laboral; ubicada en la localidad de La Concepción, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }6/N7/N7.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }6/N7/JAN7.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }6/N7/APN7.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }6/N7/AMDAPN7.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }6/N7/FAN7.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 004
            'numConvocatoria' : 'Convocatoria No. 004/2021.',
            'idConvocatoria' : 'Convocatoria4',
            'procedimientos' : [
        // Licitación N4
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N4-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 17 al 21 de mayo  de 2021.',
                    'descripcionProcedimiento' : 'Construcción del Centro Estatal de Justicia Alternativa; ubicado en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }4/N4/N4.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }4/N4/JAN4.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }4/N4/APN4.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }4/N4/FAN4.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 003
            'numConvocatoria' : 'Convocatoria No. 003/2021.',
            'idConvocatoria' : 'Convocatoria3',
            'procedimientos' : [
        // Licitación N3
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N3-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 5 al 16 de abril  de 2021.',
                    'descripcionProcedimiento' : 'Sustitución y ampliación del Hospital General de Pachuca (primera etapa); ubicado en la localidad de La Concepción, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }3/N3/N3.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }3/N3/JAN3.pdf`,
                    },
                    {
                        'resultado' : 'Aclaraciones (2da.)',
                        'urlresultado' : `${ ligabase }3/N3/2JAN3.pdf`,
                    },
                    {
                        'resultado' : 'Aclaraciones (3ra.)',
                        'urlresultado' : `${ ligabase }3/N3/3JAN3.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }3/N3/APN3.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }3/N3/FAN3.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }3/N3/AMDFAN3.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modif. dictamen',
                        'urlresultado' : `${ ligabase }3/N3/AMDDFAN3.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 002
            'numConvocatoria' : 'Convocatoria No. 002/2021.',
            'idConvocatoria' : 'Convocatoria2',
            'procedimientos' : [
        // Licitación N2
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N2-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 8 al 16 de marzo  de 2021.',
                    'descripcionProcedimiento' : 'Rehabilitación de plafón y cambio de instalación eléctrica en Casa Cuna; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
                    'urlAnexos' : `${ ligabase }2/N2/N2.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }2/N2/JAN2.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }2/N2/APN2.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }2/N2/FAN2.pdf`,
                    },
                    ],
                },
            ],
    },
    {
        // CONVOCATORIA NUM# 001
            'numConvocatoria' : 'Convocatoria No. 001/2021.',
            'idConvocatoria' : 'Convocatoria1',
            'procedimientos' : [
        // Licitación N1
                {
                    'numProcedimiento' : 'Licitación Pública No. EO-SOPOT-N1-2021.',
                    'vigencia' : 'Vigencia de venta de bases: del 1 al 5 de marzo  de 2021.',
                    'descripcionProcedimiento' : 'Elaboración del Proyecto Ejecutivo Ciudad Laboral; ubicada en la localidad y Municipio de Cobertura Estatal.',
                    'urlAnexos' : `${ ligabase }1/N1/N1.rar`,
                    'resultados' : [
                    {
                        'resultado' : 'Aclaraciones',
                        'urlresultado' : `${ ligabase }1/N1/JAN1.pdf`,
                    },
                    {
                        'resultado' : 'Oficio de diferimiento',
                        'urlresultado' : `${ ligabase }1/N1/ODN1.pdf`,
                    },
                    {
                        'resultado' : 'Anexo modificatorio',
                        'urlresultado' : `${ ligabase }1/N1/AMDJAN1.pdf`,
                    },
                    {
                        'resultado' : 'Apertura',
                        'urlresultado' : `${ ligabase }1/N1/APN1.pdf`,
                    },
                    {
                        'resultado' : 'Fallo',
                        'urlresultado' : `${ ligabase }1/N1/FAN1.pdf`,
                    },
                    ],
                },
            ],
    },
]